import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSort, MatTableDataSource, MatSnackBar } from '@angular/material';
import { AdminService } from '../../../../../../../services/admin/admin.service';
import { TdLoadingService } from '@covalent/core';

@Component({
  selector: 'app-supporters-list-dialog',
  templateUrl: './supporters-list-dialog.component.html',
  styleUrls: ['./supporters-list-dialog.component.scss']
})
export class SupportersListDialogComponent implements OnInit {
  dataSource;
  displayedColumns = ['position','name', 'date'];
  totalNumber: number;
  paging = {
    page:0,
    size:10
  }





  constructor(
    public dialogRef: MatDialogRef<SupportersListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { ideaId: number },
    private adminService: AdminService,
    private _loadingService: TdLoadingService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.getIdeaSigners(this.data.ideaId,this.paging);

  }
  closeDialog(e) {
    this.dialogRef.close();
  }
  getIdeaSigners(ideaId: number, paging) {
    this._loadingService.register()
    this.adminService.getIdeaSigners(ideaId, paging).subscribe(res=> {
      this._loadingService.resolve()
      this.dataSource = new MatTableDataSource(res.result.data)
      this.totalNumber = res.result.page.total;
    },
    (err) => {
      this._loadingService.resolve();
      this._snackBar.open('დაფიქსირდა შეცდომა',null,{
        duration:2000,
        panelClass:'red-snackbar',
        horizontalPosition:"right",
        verticalPosition:"top"
      })
    })
  }
  pageEvent(e) {
    this.paging = e;
    this.getIdeaSigners(this.data.ideaId,e);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/shared/petition-details/dialogs/supporters-list-dialog/supporters-list-dialog.component.ts